import React from 'react';

const CompanyRegistraion = () => {

    return (
        <div>
            <iframe src="https://production-easylease-storage.s3.ap-southeast-1.amazonaws.com/YFL+-+Company+Extract+1.pdf" width="100%" height="1000px" />
        </div>
    );
};

export default CompanyRegistraion;
